import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { OperatorGroupService } from '../../../../api/gen/api/operatorGroup.service';
import { OperatorGroupDto } from '../../../../api/gen/model/operatorGroupDto';

export interface UnassignParkingSpaceGroupDialogData {
  group: OperatorGroupDto;
  parkingSpaceId: string;
  parkingSpaceName?: string;
}

@Component({
  selector: 'app-unassign-parkingspace-group',
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatSnackBarModule
  ],
  templateUrl: './unassign-parkingspace-group.component.html',
  styleUrl: './unassign-parkingspace-group.component.scss'
})
export class UnassignParkingspaceGroupComponent {
  private dialogRef = inject(MatDialogRef<UnassignParkingspaceGroupComponent>);
  private data = inject<UnassignParkingSpaceGroupDialogData>(MAT_DIALOG_DATA);
  private operatorGroupService = inject(OperatorGroupService);
  private snackBar = inject(MatSnackBar);

  isRemoving = signal(false);

  get group(): OperatorGroupDto {
    return this.data.group;
  }

  get parkingSpaceName(): string {
    return this.data.parkingSpaceName || this.data.parkingSpaceId;
  }

  onConfirm(): void {
    const groupId = this.group.id;
    const spaceId = this.data.parkingSpaceId;
    if (!groupId || !spaceId) return;

    this.isRemoving.set(true);
    this.operatorGroupService.operatorGroupsOperatorGroupIdParkingSpacesParkingSpaceIdDelete(
      groupId, spaceId
    ).subscribe({
      next: () => {
        this.snackBar.open('Parking space removed from group', 'Close', { duration: 3000 });
        this.dialogRef.close(true);
      },
      error: () => {
        this.snackBar.open('Failed to remove parking space from group', 'Close', { duration: 5000 });
        this.isRemoving.set(false);
      }
    });
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
